<template>
  <div id="daftar">
    <v-container fluid>
      <div class="text-center incenter-logo">
        <a href="/">
          <v-img
            src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/smartclub247_512x512"
            height="100"
            width="200"
            class="mx-auto"
          ></v-img>
        </a>
      </div>
      <v-card height="2" color="#FF7043"></v-card>
      <v-row align="center" justify="center">
        <!-- <v-flex class="pa-3 web" xs12 md8 lg8>
          <div class="text-center">
            <v-img
              class="mx-auto"
              width="500"
              src="http://meridinet.saebo.id:2082/TestAPI/api/UploadResponse/Upload/daftar"
            ></v-img>
          </div>
        </v-flex>-->
        <v-flex class="pa-3" xs12 md4 lg4>
          <v-card raised>
            <v-container>
              <!-- <div class="text-center">
                <v-icon size="100">fas fa-money-bill-wave</v-icon>
              </div>-->
              <div class="text-center headline">Daftar Sekarang</div>
              <div class="text-center font-weight-light mb-10">
                Sudah punya akun Smart247 ?
                <v-btn color="#43A047" @click="goTo('/login')" text small>Masuk</v-btn>
              </div>
              <h3 class="mb-5">Daftar lewat Email</h3>
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-text-field
                  placeholder="Email"
                  outlined
                  v-model="email"
                  :rules="emailRules"
                  type="email"
                  label="E-mail"
                  required
                ></v-text-field>
                <div v-if="email_status != 200 && email_status != null">
                  <v-icon color="red" class="mx-2">fas fa-times</v-icon>
                  <span>Email telah terdaftar</span>
                </div>
                <v-text-field
                  v-model="handphone"
                  placeholder="Nomor HP"
                  outlined
                  :rules="phoneRules"
                  type="number"
                  label="Nomor HP"
                  required
                ></v-text-field>
                <div v-if="handphone_status != 200 && handphone_status != null">
                  <v-icon color="red" class="mx-2">fas fa-times</v-icon>
                  <span>Nomor telah terdaftar</span>
                </div>
                <v-text-field
                  v-model="password"
                  placeholder="Password"
                  outlined
                  :rules="[(v) => !!v || 'Wajib diisi !']"
                  type="password"
                  label="Password"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="nama"
                  placeholder="Nama"
                  outlined
                  :rules="[(v) => !!v || 'Wajib diisi !']"
                  type="text"
                  label="Nama"
                  required
                ></v-text-field>

                <v-btn
                  :loading="loading"
                  :disabled="!valid"
                  outlined
                  block
                  class="mr-4"
                  @click="DaftarEmail()"
                >Daftar</v-btn>

                <!-- <v-btn @click="back()" outlined class="mr-4">Kembali</v-btn> -->
              </v-form>
              <v-divider class="my-5"></v-divider>
              <!-- <h3 class="mb-5">Daftar lewat Nomor HP</h3>
              <v-form ref="bynumber" v-model="valid" lazy-validation>
                <v-text-field
                  v-model="handphone"
                  placeholder="Nomor HP"
                  outlined
                  :rules="phoneRules"
                  type="number"
                  label="Nomor HP"
                  required
                ></v-text-field>
                <div v-if="handphone_status != 200 && handphone_status != null">
                  <v-icon color="red" class="mx-2">fas fa-times</v-icon>
                  <span>Nomor telah terdaftar</span>
                </div>
                <v-btn
                  :disabled="!valid"
                  outlined
                  block
                  class="mr-4"
                  @click="reqOtp()"
                  >Daftar</v-btn
                >
              </v-form>-->
            </v-container>
          </v-card>
        </v-flex>
      </v-row>
    </v-container>
    <v-dialog v-model="overlay" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Please stand by
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Swal from "sweetalert2";
export default {
  data() {
    return {
      email: null,
      password: null,
      nama: null,
      overlay: false,
      handphone: null,
      emailRules: [
        v => !!v || "E-mail dibutuhkan",
        v => /.+@.+\..+/.test(v) || "E-mail harus valid"
      ],
      phoneRules: [v => !!v || "Masukkan nomor HP anda untuk mendaftar"],
      dataDaerah: null,
      valid: true,
      loading: false,
      email_status: null,
      handphone_status: null
    };
  },
  mounted() {},
  watch: {
    email(email) {
      var x = email.replace(".", "_");
      var y = x.replace(".", "_");
      fetch("http://meridinet.saebo.id:2082/Login/api/viewuser/email/" + y)
        .then(response => response.json())
        .then(data => {
          if (data != null) {
            this.email_status = data;
            console.log(data);
          }
        });
    },
    handphone(val) {
      fetch("http://meridinet.saebo.id:2082/Login/api/viewuser/email/" + val)
        .then(response => response.json())
        .then(data => {
          if (data != null) {
            this.handphone_status = data;
            console.log(data);
          }
        });
    }
  },
  methods: {
    DaftarEmail() {
      this.overlay = true;
      if (this.$refs.form.validate()) {
        console.log(this.email, this.password, this.nama);
        fetch("http://meridinet.saebo.id:2082/Login/api/SignUp", {
          method: "POST",
          body: JSON.stringify({
            email: this.email,
            password: this.password,
            nama: this.nama,
            nohp: this.handphone
          }),
          headers: {
            "Content-type": "application/json"
          }
        })
          .then(response => response.json())
          .then(data => {
            console.log(data);
            localStorage.setItem("token", data.token);
            localStorage.setItem("user_id", data.id);
            localStorage.setItem("idkeranjang", data.keranjang);
            localStorage.setItem("alamat_id", data.alamat_id);
            Swal.fire("Sukses", "Akun berhasil dibuat", "success");
            this.$router.push("/");
            this.overlay = false;
          });
      }
    },
    reqOtp() {
      if (this.$refs.bynumber.validate()) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!"
        }).then(result => {
          if (result.value) {
            this.overlay = true;
            fetch(
              "http://saebo.technology/apisms/capi/regis/" +
                this.handphone +
                "/incenter"
            ).then(response => {
              response.json();
              this.$router.push("bynumber" + this.handphone);
              this.overlay = false;
            });
          }
        });
      }
    },
    validate() {
      this.$refs.form.validate();
    },

    goTo(e) {
      this.$router.push(e);
    },
    back() {
      window.history.back();
    }
  }
};
</script>
<style scoped>
#daftar {
  background: #455a64;
  height: 100%;
}
.incenter-logo {
  font-family: Tahoma, Geneva, sans-serif;
  font-size: 300%;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #ff3d00;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: uppercase;
}
.incenter-logo-id {
  font-family: "Palatino Linotype", "Book Antiqua", Palatino, serif;
  font-size: 25px;
  letter-spacing: 2px;
  word-spacing: 2px;
  color: #546e7a;
  font-weight: 700;
  text-decoration: none;
  font-style: normal;
  font-variant: normal;
  text-transform: lowercase;
}
@media only screen and (max-width: 768px) {
  .web {
    display: none;
  }
}
</style>
